export enum ActionStatus {
    idle="idle",
    loading="loading",
    succeeded="succeeded",
    failed="failed"
  }